export const windowsId = "41ab9723-a13f-410a-86c3-138c35f24c57";
export const ubuntuId = "9112c9f3-7a49-4b6a-8bb1-1b441c112c8a";
export const jhvVmId = "95ed8772-6cae-4dce-bf3d-97ffcdaaabbf";
